import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingDialogService } from '../../../shared/ui/loading/loading-dialog.service';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { CreditosConEmpleadosModel } from './creditos-con-empleados.model';
import { CreditosConEmpleadosService } from './creditos-con-empleados.service';

@Component({
    selector: 'convfact-creditos-con-empleados',
    templateUrl: './creditos-con-empleados.component.html',
    styleUrls: ['./creditos-con-empleados.component.css'],
    standalone: false
})

export class CreditosConEmpleadosComponent implements OnInit {

  public creditosConEmpleados = new CreditosConEmpleadosModel;
  public spinner: boolean = false;
  public ready: boolean = false;

  constructor(
    private creditosConEmpleadosService: CreditosConEmpleadosService,
    public snackBar: MatSnackBar,
    private router: Router,
    private loadingDialog: LoadingDialogService,
    private notify: NotificationService,
  ) { }

  public ngOnInit(): void {
    const temp = this.router.url.split('/');
    this.spinner = true;
    if (temp.length == 6) {
      const uid = temp[5];
      this.creditosConEmpleadosService.get(uid)
        .then(response => {
          this.creditosConEmpleados = response;
          this.spinner = false;
          this.ready = true;
        })
        .catch(() => {
          this.spinner = false;
          this.notify.error('No se pudo cargar el crédito');
        });
    }
    else {
      this.spinner = false;
      this.ready = true;
    }

  }

  public saveData(creditosConEmpleados: CreditosConEmpleadosModel): void {
    const isNew = creditosConEmpleados.uid == null;
    const request = isNew
      ? this.creditosConEmpleadosService.add(creditosConEmpleados)
      : this.creditosConEmpleadosService.edit(creditosConEmpleados);

    this.spinner = true;
    this.loadingDialog.run(isNew ? 'Creando crédito…' : 'Guardando crédito…', request.then(ok => { if (ok !== true) throw new Error(); }))
      .then(() => {
        this.notify.ok(isNew ? 'Crédito creado correctamente' : 'Crédito actualizado correctamente');
        this.returnToIndex();
      })
      .catch(error => {
        const serverMessage = error && error.error && error.error.message;
        this.notify.error(serverMessage || (isNew ? 'Ha ocurrido un error inesperado al crear el crédito' : 'Ha ocurrido un error inesperado al actualizar el crédito'));
      })
      .then(() => { this.spinner = false; });
  }

  public displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(error, '', options);
  }

  public returnToIndex(): void {
    this.router.navigate(['finance/credits/creditswithemployees']);
  }
}
